import { currencyFormatter } from "../../../../utils/formatter/formatter";

export function StockBreakCard({ ctx }) {
  const { generalAverage, stores, totalEstimatedLoss } = ctx || {};

  const maxVal = Math.max(...stores.map((s) => s.value));

  return (
    <div style={{
      background: "#fff",
      borderRadius: "1.5rem",
      padding: "1.25rem",
      boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      border: "1px solid #E5E7EB",
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
    }}>
      <p style={{
        fontWeight: "bold", 
        fontSize: "1rem", 
        letterSpacing: "0.05em", 
        color: "#6B7280", 
        margin: 0 
      }}>
        PRODUTOS COM QUEBRA
      </p>
      <small style={{ color: "#6B7280", fontSize: "0.7rem" }}>
        Vendas Perdidas (em Peças) por Estoque zerado
      </small>

      <div style={{ textAlign: "center", margin: "1rem 0" }}>
        <strong style={{
          fontSize: "2rem",
          fontWeight: "700",
          color: "#111827",
          fontFamily: "'Public Sans', system-ui, sans-serif",
        }}>
          {generalAverage}
        </strong>
        <p style={{ fontSize: "0.7rem", color: "#6B7280", fontWeight: "700", margin: 0 }}>
          MÉDIA GERAL · PEÇAS
        </p>
      </div>

      {/* Bar chart */}
      <div style={{ display: "flex", gap: 10, height: 175, alignItems: "stretch", padding: "0 4px" }}>
        {stores.map((store) => {
          const heightPct = maxVal > 0 ? (store.value / maxVal) * 100 : 0;
          const gradLight = "#F9A469";
          const gradDark  = "#ED701D";
          return (
            <div key={store.name} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
              {/* Gray container: rounded top only, flat base, overflow:hidden clips orange fill */}
              <div style={{
                width: "100%",
                flex: 1,
                borderRadius: "16px 16px 0 0",
                background: "#E5E7EB",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                overflow: "hidden",
              }}>
                {/* Orange fill: rounded top, flat base (container clips bottom) */}
                <div style={{
                  width: "100%",
                  height: `${heightPct}%`,
                  background: `linear-gradient(to bottom, ${gradLight}, ${gradDark})`,
                  borderRadius: "16px 16px 0 0",
                  position: "relative",
                  minHeight: 30,
                }}>
                  <span style={{
                    position: "absolute",
                    top: 7,
                    left: "50%",
                    transform: "translateX(-50%)",
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: 12,
                    userSelect: "none",
                    whiteSpace: "nowrap",
                    fontFamily: "'Public Sans', system-ui, sans-serif",
                  }}>
                    {store.value}
                  </span>
                </div>
              </div>
              <span style={{ fontSize: 11, fontWeight: 800, color: "#374151", whiteSpace: "nowrap" }}>
                {store.name}
              </span>
            </div>
          );
        })}
      </div>

      <hr style={{ border: "none", borderTop: "1px solid #F3F4F6", margin: "0", marginTop: "auto", marginBottom: "0.8rem" }} />

      <div style={{
        background: "#FFF7ED",
        border: "1px solid #FED7AA",
        borderRadius: "1rem",
        padding: "0.75rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "0.7rem",
        color: "#374151",        
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <div style={{
            width: 38, height: 38,
            borderRadius: "0.5rem",
            background: "#FED7AA",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}>
            {/* PackageX: box with X mark indicating stock loss */}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C2410C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 10.5V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l3.5-2"/>
              <polyline points="3.29 7 12 12 20.71 7"/>
              <line x1="12" y1="22" x2="12" y2="12"/>
              <path d="m17 13 5 5"/>
              <path d="m22 13-5 5"/>
            </svg>
          </div>
          <div>
            <p style={{ margin: 0, fontWeight: "bold", fontSize: "0.7rem", color: "#F97316" }}>
              PERDA TOTAL ESTIMADA
            </p>
            <p style={{ margin: 0, fontSize: "0.65rem", color: "#6B7280" }}>
              Impacto financeiro acumulado
            </p>
          </div>
        </div>
        <strong style={{
          color: "#F97316",
          fontSize: "1.25rem",
          fontWeight: "700",
          fontFamily: "'Public Sans', system-ui, sans-serif",
          fontVariantNumeric: "tabular-nums",
          whiteSpace: "nowrap",
        }}>
          {currencyFormatter.format(totalEstimatedLoss)}
        </strong>
      </div>
    </div>
  );
}
